import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../config/api.config';
import { ApiResponse } from '../models/api.model';
import {
  EmpresaUsuarioForm,
  EmpresaUsuarioRole,
  EmpresaUsuariosPage,
  EmpresaUsuariosResumen,
} from '../models/empresa-usuario.model';

@Injectable({ providedIn: 'root' })
export class EmpresaUsuariosService {
  private readonly http = inject(HttpClient);
  private readonly url = `${API_URL}/empresa/usuarios`;

  resumen(): Observable<ApiResponse<EmpresaUsuariosResumen>> {
    return this.http.get<ApiResponse<EmpresaUsuariosResumen>>(`${this.url}/resumen`);
  }

  roles(): Observable<ApiResponse<EmpresaUsuarioRole[]>> {
    return this.http.get<ApiResponse<EmpresaUsuarioRole[]>>(`${this.url}/roles`);
  }

  paginado(
    page: number,
    pageSize: number,
    search: string,
    status: string,
    sortBy?: string,
    sortDirection?: 'asc' | 'desc',
  ): Observable<EmpresaUsuariosPage> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (search.trim()) params = params.set('search', search.trim());
    if (status !== 'Todos') params = params.set('status', status);
    if (sortBy) params = params.set('sortBy', sortBy);
    if (sortDirection) params = params.set('sortDirection', sortDirection);
    return this.http.get<EmpresaUsuariosPage>(`${this.url}/paginado`, { params });
  }

  crear(request: EmpresaUsuarioForm): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(this.url, request);
  }

  actualizar(id: string, request: EmpresaUsuarioForm): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.url}/${id}`, request);
  }

  activar(id: string): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.url}/${id}/activar`, null);
  }

  desactivar(id: string): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.url}/${id}/desactivar`, null);
  }

  restablecerPassword(id: string, password: string): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.url}/${id}/password`, { password });
  }
}
